<div class="mb-3">
  <h1 class="pb-2 border-bottom fw-light" data-testid="reference-translations-heading" i18n>
    Übersetzungen
  </h1>

  <p class="text-muted" i18n>
    Die Bezeichnungen der Stammdaten, die Käufer und Verkäufer auf der Oberfläche lesen. Die
    deutsche Spalte stammt aus den Daten selbst und wird hier nur angezeigt — sie ist zugleich die
    Grundlage der automatischen Kategorieerkennung. Gespeichert wird zeilenweise; eine geänderte
    Bezeichnung wird von einem Seeding-Lauf nicht mehr überschrieben.
  </p>

  @if (loading) {
    <p class="text-muted" i18n>Wird geladen …</p>
  } @else if (!view) {
    <div class="alert alert-danger" role="alert" data-testid="reference-translations-error" i18n>
      Die Übersetzungen konnten nicht geladen werden.
    </div>
  } @else {
    @for (set of rowsByType; track set.entityType) {
      <section class="mt-4">
        <h2 class="h5">{{ setTitle(set.entityType) }}</h2>

        @if (!set.rows.length) {
          <p class="text-muted" i18n>Keine Einträge vorhanden.</p>
        } @else {
          <kendo-grid
            [data]="set.rows"
            [sortable]="false"
            [pageable]="false"
            [attr.data-testid]="'reference-translations-grid-' + set.entityType"
          >
            <kendo-grid-column field="key" i18n-title title="Schlüssel" [width]="200">
              <ng-template kendoGridCellTemplate let-dataItem>
                <code>{{ dataItem.key }}</code>
              </ng-template>
            </kendo-grid-column>

            <!-- The source language: the entity's own text, shown so the curator can see what
                 they are translating, never editable here. -->
            <kendo-grid-column
              field="sourceName"
              [title]="sourceLanguage | uppercase"
              [width]="220"
            >
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="text-muted">{{ dataItem.sourceName }}</span>
              </ng-template>
            </kendo-grid-column>

            @for (language of editableLanguages; track language) {
              <kendo-grid-column [title]="language | uppercase">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="100"
                    [attr.data-testid]="'reference-translation-input-' + dataItem.id + '-' + language"
                    [attr.aria-label]="setTitle(set.entityType) + ' — ' + dataItem.key"
                    [value]="dataItem.edited[language] ?? ''"
                    (input)="onInput(dataItem, language, $any($event.target).value)"
                  />
                </ng-template>
              </kendo-grid-column>
            }

            <kendo-grid-column [width]="180">
              <ng-template kendoGridCellTemplate let-dataItem>
                <button
                  class="btn btn-sm btn-primary me-2"
                  type="button"
                  [asyncClick]="onSave(dataItem)"
                  [disabled]="saveBtn.disabled || !isChanged(dataItem)"
                  #saveBtn="asyncClick"
                  [attr.data-testid]="'reference-translation-save-' + dataItem.id"
                  i18n
                >
                  @if (saveBtn.busy) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                  }
                  Speichern
                </button>
                <button
                  class="btn btn-sm btn-outline-secondary"
                  type="button"
                  [disabled]="!isChanged(dataItem)"
                  (click)="onReset(dataItem)"
                  i18n
                >
                  Verwerfen
                </button>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        }
      </section>
    }
  }

  <div class="mt-4">
    <button
      class="btn btn-secondary"
      type="button"
      (click)="onBackClicked()"
      data-testid="reference-translations-back-button"
      i18n
    >
      Zurück
    </button>
  </div>
</div>
